<template>
  <div v-if="image">
    <v-card
        class="rounded-xl"
        elevation="5"
        width="450"
    >
      <v-img :src="image.url"
             label="Image"
             contain
      >
      </v-img>
    </v-card>
  </div>

  <div v-else>
    <div class="pp-center mb-5">
      <v-icon size="200">
        mdi-image-off-outline
      </v-icon>
    </div>

    <div class="error--text pt-4 ml-0 pl-0">
      A course image should be set.
    </div>
  </div>
</template>

<script>

export default {
  name: "ReviewImage",
  props: {
    image: Object,
  },
};
</script>
